import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop, isEqual } from 'lodash';

import { View } from '@dbk/ui-react-utils';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import { AccordionPlusIcon, AccordionMinusIcon } from '../icons';

import ExpandableListRow from '../expandable-list-view/expandable-list-row';

import styles from "./asset-accordion.styles";

class AssetAccordion extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      activeItems: this.props.activeItems.concat(this.props.state.expandedItem !== null ? [this.props.state.expandedItem] : []),
    }
  }

  static propTypes = {
    state: PropTypes.shape({
      expandedItem: PropTypes.string,
      setExpandedItem: PropTypes.func,
      setExpandedItemOffset: PropTypes.func,
    }),
    detailsGroups: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
    }))),
    rows: PropTypes.array.isRequired,
    renderRow: PropTypes.func.isRequired,
    renderRowExpanded: PropTypes.func.isRequired,
    activeItems: PropTypes.array,
    allowMultiple: PropTypes.bool,
    rememberState: PropTypes.bool,
    testID: PropTypes.string,
    renderIconForClose: PropTypes.func,
    renderIconForOpen: PropTypes.func,
    isPosTransFactory: PropTypes.bool
  };


  static defaultProps = {
    state: {
      expandedItem: null,
      setExpandedItem: noop,
      setExpandedItemOffset: noop,
    },
    rows: [],
    detailsGroups: [],
    activeItems: [],
    renderRow: noop,
    renderRowExpanded: noop,
    allowMultiple: false,
    testID: 'expandable-list-view',
    rememberState: false,
    renderIconForClose: () => <AccordionPlusIcon />,
    renderIconForOpen: () => <AccordionMinusIcon />
  };

  componentWillUnmount(){
     this.props.state.setExpandedItem(null);
  }
  /*
   * Commented componentWillReceiveProps, while developing Trading CTA api integration
   * Observation: below code is closing Accordion and setting activeItems to [] 
   * if new props are coming up EBANK-16663
   */
  componentWillReceiveProps(nextProps) {
    if (
      !isEqual(nextProps.activeItems, this.state.activeItems) ||
      !isEqual(this.props.state.expandedItem, nextProps.state.expandedItem)) {
      this.setState({
        activeItems: nextProps.activeItems.concat(nextProps.state.expandedItem ? 
     [nextProps.state.expandedItem] : []),
      })
    }
  }

  renderRows() {
    const {
      rows,
      renderRow,
      renderRowExpanded,
      messages
    } = this.props;

    return rows.map((row, index) => (
      <AccordionItem
        itemKey={index}
        key={index}
        renderTitle={() => {
          return (
            <ExpandableListRow
              expanded={this.state.activeItems.indexOf(index) !== -1}
              messages={messages}
            >
              {renderRow(row)}
            </ExpandableListRow>
          )
        }}>
        { this.state.activeItems.indexOf(index) !== -1 &&
          renderRowExpanded(row)
        }
      </AccordionItem>)
    )
  }

  handleChange = (activeItems) => {
    this.setState({
      activeItems
    }, () => {
      if (this.props.rememberState && this.props.state.setExpandedItem) {
        const [rowId] = activeItems;
        if (rowId) {
          this.props.state.setExpandedItem(rowId);
        }
      }

    })
  };

  render() {
    const { footer, testID, renderIconForClose, renderIconForOpen, isPosTransFactory } = this.props;
    return (
      <View
        style={styles.root}
        testID={testID}
      > {isPosTransFactory ?
          <div style={{paddingLeft: '20px'}} className="asset-accordion">
            <Accordion
              testID="list"
              fullWidth
              activeItems={this.state.activeItems}
              onChange={this.handleChange}
              renderIconForOpen={renderIconForOpen}
              renderIconForClose={renderIconForClose}
            >
              {this.renderRows()}
            </Accordion>
          </div>
          :
          <div className="asset-accordion">
            <Accordion
              testID="list"
              fullWidth
              activeItems={this.state.activeItems}
              onChange={this.handleChange}
              renderIconForOpen={renderIconForOpen}
              renderIconForClose={renderIconForClose}
            >
              {this.renderRows()}
            </Accordion>
          </div>
        }
        {footer && footer}
      </View>
    );
  }
}

export default AssetAccordion;
